import React from 'react';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Facebook as FacebookIcon,
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
} from './socialIcons';

const dumbFooter = dumbBem('l-footer');
const Icon = tx([{ element: 'icon' }, dumbFooter])('div');
const socials = [
  {
    id: 1,
    Icon: FacebookIcon,
    onClick: () => {},
  },
  {
    id: 2,
    Icon: GitHubIcon,
    onClick: () => window.open('https://github.com/iteriodata'),
  },
  {
    id: 3,
    Icon: LinkedInIcon,
    onClick: () => window.open('https://www.linkedin.com/company/iterio-data'),
  },
  {
    id: 4,
    Icon: TwitterIcon,
    onClick: () => window.open('https://twitter.com/iteriodata'),
  },
];

const Socials = () => {
  return (
    <React.Fragment>
      {socials.map(Social => (
        <Icon key={Social.id} onClick={Social.onClick}>
          <Social.Icon />
        </Icon>
      ))}
    </React.Fragment>
  );
};

export default Socials;



// WEBPACK FOOTER //
// ./src/components/landing/components/footer/Socials.js